<template>
  <div id="password-change-wrapper">
    <h2 class="my-page-header">パスワードの変更</h2>
    <p id="password-complete-message">パスワードの再設定が完了しました</p>
    <div class="button-wrapper">
      <button @click="navigateToTop" class="submit-button top-button round-button">
        マイページTOPへ
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChangePasswordComplete',
  methods: {
    navigateToTop() {
      this.$emit('updated', 'top');
    },
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../assets/style/parts_responsive.scss";

#password-complete-message {
  padding: 90px 30px 60px;
  text-align: center;
  font-size: 16px;
}

.button-wrapper {
  display: flex;
  width: 320px;
  margin: auto;
  margin-bottom: 20px;
}

@media (min-width: 640px) {
  #password-change-wrapper {
    border: 1px solid #CCCCCC;
    border-radius: 14px;
    background-color: white;
    margin: auto;
    padding: 28px;
    width: 720px;
    margin-bottom: 100px;
  }
}
</style>
